import { Tooltip } from "@mui/material"
import { CityFromSection } from "hooks/returnCityName"
import NumberFormat from "react-number-format"
import { Space, Row, Typography, Tag } from "antd"
const { Text, Link } = Typography

export const renderRowNumber = (index, { pageIndex, pageSize }) => {
  return (pageIndex - 1) * pageSize + index + 1
}

export const columnsClientGrid = props => [
  {
    title: "#",
    key: "id",
    render: (id, record, index) => renderRowNumber(index, props),
    width: "3rem",
  },
  {
    title: "مبلغ-ریال",
    key: "fullName",
    render: row => (
      <Text>
        {row.amount?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
      </Text>
    ),
    width: "6rem",
  },
  {
    title: "تاریخ تراکنش/کد پیگیری",
    key: "solarCreated",
    render: row => (
      <div className="d-flex flex-column gap-2 justify-content-center align-items-center">
        <Tag>{row.solarCreated?.substr(0, 10)}</Tag>
        <Tag>{row.bankTransactionId}</Tag>
      </div>
    ),
    width: "10rem",
  },
  {
    title: "نام مالک/مجری",
    key: "fullName",
    render: row => (
      <div className="d-flex flex-column gap-2 justify-content-center align-items-center">
        <Tag>{row.landLordName}</Tag>
        <Tag>{row.executorName}</Tag>
      </div>
    ),
    width: "8rem",
  },
  // {
  //   title: "شهر",
  //   key: "idCity",
  //   render: row => (
  //     <Text>{row.cityName}</Text>
  //   ),
  //   width: "5rem",
  // },
  {
    title: "درگاه پرداخت",
    key: "fullName",
    render: row => <Text>{row.gatewayTypeName}</Text>,
    width: "5rem",
  },
  {
    title: "واریز/برداشت",
    key: "transactionStatusName",
    render: row => <Text>{row.transactionStatusName}</Text>,
    width: "4rem",
  },
  {
    title: "مربوط به پرونده",
    key: "fileNumber",
    render: row => <Text>{row.fileNumber}</Text>,
    width: "6rem",
  },
  {
    title: "توضیحات",
    key: "des",
    render: row => <Text>{row.des}</Text>,
    width: "12rem",
  },
]
